"use client";
import Image from "next/image";
import React, { useState } from "react";
import FsLightbox from "fslightbox-react";

const GallerySection = () => {
  const [toggler, setToggler] = useState(false);
  const [productIndex, setProductIndex] = useState(0);

  const photos = [
    "/images/gallery/gallery1.jpg",
    "/images/gallery/gallery2.jpg",
    "/images/gallery/gallery3.jpg",
    "/images/gallery/gallery4.jpg",
    "/images/gallery/gallery5.jpg",
    "/images/gallery/gallery6.jpg",
    "/images/gallery/gallery7.jpg",
    "/images/gallery/gallery8.jpg",
    "/images/gallery/gallery9.jpg",
    "/images/gallery/gallery10.jpg",
    "/images/gallery/gallery11.jpg",
    "/images/gallery/gallery12.jpg",
    "/images/gallery/gallery13.jpg",
    "/images/gallery/gallery14.jpg",
    "/images/gallery/gallery15.jpg",
    "/images/gallery/gallery16.jpg",
    "/images/gallery/gallery17.jpg",
    "/images/gallery/gallery18.jpg",
    "/images/gallery/gallery19.jpg",
    "/images/gallery/gallery20.jpg",
    "/images/gallery/gallery21.jpg",
    "/images/gallery/gallery22.jpg",
    "/images/gallery/gallery23.jpg",
    "/images/gallery/gallery24.jpg",
    "/images/gallery/gallery25.jpg",
    "/images/gallery/gallery26.jpg",
    "/images/gallery/gallery27.jpg",
    "/images/gallery/gallery28.jpg",
    "/images/gallery/gallery29.jpg",
    "/images/gallery/gallery30.jpg",
  ];

  return (
    <div>
      <div className="bg-white">
        <div className="max-w-screen-xl mx-auto text-center py-6">
          <div className="py-20">
            <FsLightbox
              toggler={toggler}
              sources={photos}
              type="image"
              slide={productIndex}
            />
            <div className="max-w-screen-xl mx-auto">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 px-5">
                {photos.map((photo, index) => (
                  <div
                    key={index}
                    className="relative w-full h-0 pb-[75%] cursor-pointer overflow-hidden"
                    onClick={() => {
                      setProductIndex(index + 1);
                      setToggler(!toggler);
                    }}
                  >
                    <Image
                      src={photo}
                      alt={`gallery image ${index + 1}`}
                      layout="fill"
                      objectFit="cover"
                      className="hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GallerySection;
